export default "__VITE_ASSET__2BHXCEzG__"